import React from 'react'
import Markdown from 'markdown-to-jsx'
import ppDeMd from './pp-de.md'

const PrivacyPolicyDE = () => {
  return <Markdown>{ppDeMd}</Markdown>
}

export default PrivacyPolicyDE
